import { Injectable } from "@angular/core";
import { BackendHttpClient, DefaultResponseData } from "@api/http";
import { Observable } from "rxjs";

export interface FundingRequestActionData {
  action: string;
  label: string;
}

export interface FundingRequestData {
  id: number;
  account_id: number;
  account?: FundingRequestAccountData | null;
  amount: number;
  currency: string;
  funds_needed_by: string | null;
  note?: string | null;
  attachments?: FundingRequestAttachmentData[];
  status: string;
  available_actions?: FundingRequestActionData[];
  created_at: string | null;
  updated_at: string | null;
}

export interface FundingRequestAccountData {
  id: number;
  provider_account_id: string | null;
  currency: string | null;
  provider_status: string | null;
  amount: number | null;
  is_active: boolean;
  account_details?: FundingRequestAccountDetailData[];
  created_at: string | null;
  updated_at: string | null;
}

export interface FundingRequestAccountDetailData {
  id: number;
  account_name: string | null;
  account_address: string | null;
  account_number_type: string | null;
  account_number: string | null;
  bank_identifier: string | null;
  bank_identifier_type: string | null;
}

export interface FundingRequestAttachmentData {
  id: number;
  name: string | null;
  type: string | null;
  file_path: string | null;
  size: number | null;
  document_id: number | null;
}

export interface FundingRequestPageData {
  currentPage: number;
  perPage: number;
  lastPage: number;
  total: number;
  items: FundingRequestData[];
}

@Injectable({
  providedIn: "root",
})
export class FundingRequestsService {
  constructor(private http: BackendHttpClient) {}

  getClientFundingRequests(
    clientId: number,
    params = {}
  ): Observable<DefaultResponseData<FundingRequestPageData>> {
    return this.http.get<DefaultResponseData<FundingRequestPageData>>(
      `payouts/clients/${clientId}/funding-requests`,
      { params }
    );
  }

  getClientFundingRequest(
    clientId: number,
    fundingRequestId: number
  ): Observable<DefaultResponseData<FundingRequestData>> {
    return this.http.get<DefaultResponseData<FundingRequestData>>(
      `payouts/clients/${clientId}/funding-requests/${fundingRequestId}`
    );
  }

  markClientFundingRequestAsFunded(
    clientId: number,
    fundingRequestId: number
  ): Observable<DefaultResponseData<FundingRequestData>> {
    return this.http.post<DefaultResponseData<FundingRequestData>>(
      `payouts/clients/${clientId}/funding-requests/${fundingRequestId}/fund`,
      {}
    );
  }
}
